<template>
  <div id="smsSystem" v-loading="isLoading">
    <!-- <header-top :headerText="headerText"></header-top> -->
    <main class="main">
      <el-form label-position="left">
        <div class="form-info">
          <div class="sms-settings">
            <div class="tit">短信设置</div>
            <el-form-item
              v-for="(item, index) in smsSettings"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{ item.displayName }}</div>
              <el-checkbox
                v-model="item.value"
                v-if="
                  item.value === true ||
                  item.value === false ||
                  item.value === 'true' ||
                  item.value === 'false'
                "
                >{{ item.displayName }}</el-checkbox
              >
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
          <div class="btn-group">
            <el-button
              type="primary"
              @click="smsSubmit"
              :loading="isSmsLoadingSubmit"
              >保存</el-button
            >
            <el-button @click="smsReduction" :loading="isSmsCloaseLoading"
              >重置</el-button
            >
          </div>
        </div>
      </el-form>
    </main>
  </div>
</template>

<script>
// import headerTop from "@/components/HeaderTop";

import {
  getIdentitySettings,
  updateIdentitySettings,
  getSmsSettings,
  updateSmsSettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
export default {
  props: {
    isEdit: { type: Boolean },
  },
  components: {
    // headerTop,
  },
  data() {
    return {
      headerText: "账户配置",
      requireData: [],
      smsSettings: [],
      permissions: this.$store.getters.permissions,
      isCloaseLoading: false,
      isLoadingSubmit: false,
      isSmsCloaseLoading: false,
      isSmsLoadingSubmit: false,
      initial: [],
      isLoading:true
    };
  },
  mounted() {
    this.getSmsSettings();
  },
  methods: {
   
    smsSubmit() {
      if (this.permissions["System.SmsSettings.Update"]) {
        this.isSmsLoadingSubmit = true;
        let settings = {
          settings: this.requireData,
        };
        console.log(this.$store.getters.generateUpdateSettingsParams,1111);
        updateSmsSettings(
          {
            settings: this.smsSettings,
          },
          this.$store.getters.generateUpdateSettingsParams
        ).then((res) => {
          this.isSmsLoadingSubmit = false;
          this.$message({
            message: res.message,
            type: "success",
          });
        });
      } else {
        this.smsReduction();
        this.$message.warning({
          message: `您暂无短信配置权限`,
          showClose: true,
        });
      }
    },
    smsReduction() {
      this.isSmsCloaseLoading = true;
      this.getSmsSettings();
      this.isSmsCloaseLoading = false;
    },

    getSmsSettings() {
      this.isLoading = true
      getSmsSettings().then((res) => {
        this.smsSettings = deepCopy(res.result);
        setTimeout(()=>{
          this.isLoading = false
        },300)
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";

#smsSystem {
  .main {
    min-width: 900px;
    min-height: calc(100vh - 150px);
    text-align: left;

    .form-info {
      margin-bottom: 20px;
      padding: 20px;
      background: #fff;
    }
    .form-info:last-child{
      margin-bottom: 0px;
    }
    .sms-settings {
      // margin-bottom: 20px;
      padding-bottom: 10px;
      border-radius: $--border-radius-base;
      .tit {
        margin-bottom: 25px;
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
      .custom-height {
        margin-bottom: 20px;
      }
      .tips {
        margin-top: 7px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #878787;
      }

      .el-form-item {
        margin-bottom: 25px;
      }
      ::v-deep .el-form-item__content {
        .el-checkbox {
          margin-right: 0;
          .el-checkbox__label {
            padding-left: 6px;
            color: #2c3e50;
          }
        }
        .el-radio-button__inner {
          height: 30px;
          line-height: 10px;
        }
      }
      .el-input {
        width: 332px;
      }
      .prefix {
        @include flex(row, center);
        img {
          margin: 0 12px;
          width: 10px;
          height: 10px;
        }
        .el-input {
          margin-bottom: 10px;
          width: 124px;
        }
      }
      .template {
        margin: 5px 0 4px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #888;
      }
      .prefix-tips {
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #ff9d00;
      }
    }
  }
}
</style>
